import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Components from '..';
import Pictures from '../../assets/picture';
import { LocalStorageKeys } from '../../config/globalVariables';
import './Cookies.scss';
import getPrivacyPolicyLink from '../../utils/getPrivacyPolicyLink';
import getClientsStyle from '../../utils/getClientsStyle';

const Cookies = () => {
  const { t } = useTranslation('components');
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const privacyPolicyLink = getPrivacyPolicyLink();
  const styleForClient = getClientsStyle();

  const grantConsent = (bool: 'true' | 'false') => {
    localStorage.setItem(LocalStorageKeys.CookiesConsent, bool);
    setIsVisible(false);
  };

  useEffect(() => {
    if (localStorage.getItem(LocalStorageKeys.CookiesConsent) === null) {
      setIsVisible(true);
    }
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="berg-components-cookies">
      <img src={Pictures.Cookies} alt="cookies" />
      <p>
        <Trans
          ns="components"
          i18nKey="cookies.text"
          components={{
            a: (
              <a
                href={privacyPolicyLink}
                target="_blank"
                rel="noopener noreferrer"
                className="berg-components-cookies__link"
                data-client-style={styleForClient}
              />
            ),
          }}
        ></Trans>
      </p>
      <div className="berg-components-cookies__buttons">
        <Components.BergButton
          label={t('cookies.consent')}
          className="berg-button berg-button__primary color"
          data-client-style={styleForClient}
          onClick={() => grantConsent('true')}
        />
      </div>
    </div>
  );
};

export default Cookies;
